export default __webpack_public_path__ + "static/media/michigan.0b22ca55.jpg";